import { createFileRoute, redirect } from '@tanstack/react-router'

import { logSentry } from '@gto/sentry'
import { sessionStore } from '@gto/session'

import { LoginExplainer } from '@/pages/login/login-explainer'
import { loginSearchSchema } from '@/pages/login/login-search'
import { buildOAuthRedirectUrl } from '@/utils/oauth'

export const Route = createFileRoute('/login')({
  component: LoginRoute,
  validateSearch: loginSearchSchema,
  beforeLoad: async ({ search }) => {
    if (search.auto === undefined) {
      return
    }

    if (sessionStore.getState().accessToken !== null) {
      throw redirect({ href: search.from ?? '/', replace: true })
    }

    let href: string
    try {
      href = await buildOAuthRedirectUrl(search.from)
    } catch (e: unknown) {
      logSentry('admin-web: automatic sign-in could not start', e)

      throw redirect({
        to: '/login',
        replace: true,
        search: { ...search, auto: undefined, reason: 'auto_start_failed' },
      })
    }

    throw redirect({ href })
  },
})

function LoginRoute() {
  const { from, reason } = Route.useSearch()

  return (
    <LoginExplainer
      from={from}
      reason={reason}
    />
  )
}
